import { useEffect, useState } from "react";
import { getWeb29OfferState, Web29OfferState } from "../web29Offer";

// Tracks the web29 legit-timer offer for the anchor arm. Re-evaluates every
// second but only re-renders the caller when the STATUS changes (e.g. live →
// expired mid-visit); the banner keeps its own per-100ms countdown.
export function useWeb29Offer(enabled: boolean): Web29OfferState | null {
  const [state, setState] = useState<Web29OfferState | null>(() =>
    enabled ? getWeb29OfferState() : null
  );

  useEffect(() => {
    if (!enabled) {
      setState(null);
      return;
    }
    const tick = () => {
      const next = getWeb29OfferState();
      setState((prev) =>
        prev &&
        prev.status === next.status &&
        prev.expiresAt === next.expiresAt &&
        prev.showCountdown === next.showCountdown
          ? prev
          : next
      );
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [enabled]);

  return enabled ? state : null;
}
